<template>
  <b-row>
    <b-col md="3" class="my-1">
      <search-input placeholder="البحث بحسب الأسم" v-model="search.name" />
    </b-col>
    <b-col md="3" class="my-1">
      <search-input
        placeholder="البحث بحسب الرقم الوطني"
        v-model="search.id_number"
      />
    </b-col>
    <b-col md="3" class="my-1">
      <FormSelect
        :options="statusOptions"
        v-model="search.status"
        placeholder="الحالة"
        :reduce="(x) => x.value"
      />
    </b-col>
    <b-col cols="3">
      <div class="d-flex justify-content-end">
        <b-button variant="primary" class="mt-1" @click="clearAllFilters()"
          >إلغاء البحث</b-button
        >
      </div>
    </b-col>
  </b-row>
</template>

<script>
import SearchInput from "@/components/SearchInput.vue";
import { BRow, BCol, BButton } from "bootstrap-vue";
import debounce from "lodash.debounce";
import FormSelect from "@/components/form-select";

export default {
  components: { SearchInput, BRow, BCol, BButton, FormSelect },
  data() {
    return {
      search: {},
      statusOptions: [
        { label: "نشط", value: true },
        { label: "غير نشط", value: false },
      ],
    };
  },
  watch: {
    search: {
      deep: true,
      handler: debounce(function (val) {
        this.$emit("filterChanged", val);
      }, 500),
    },
  },
  methods: {
    clearAllFilters() {
      if (Object.keys(this.search).length > 0) this.search = {};
    },
  },
};
</script>
